import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { RESPONSE_GIVEN, NO_RESPONSE_GIVEN } from '../../constants/input.constants';

@Component({
  selector: 'app-text-custom-dropdown',
  templateUrl: './text-custom-dropdown.component.html',
  styleUrls: ['./text-custom-dropdown.component.less']
})
export class TextCustomDropdownComponent implements OnInit, OnDestroy {


    @Input() dropdownLabel: string;
    @Input() showAny: boolean;
    @Input() fieldName: string;
    @Input() colorStyle: string;
    @Input() sourceList: any[];
    @Input() upperDropdown: boolean;
    @Input() disabled = false;
    @Input() showOneLine = false;
    showError = false;
    @Input() eventValidate: Observable<number[]>;
    @Input() eventValidateSubscription: any;
    @Input() id: number;
    @Input() filterOperators: string[];
    @Input() operatorSelected: string;
    inputValue: string;

    @Output() userChoice: EventEmitter<any> = new EventEmitter<any>();

    dropdown: boolean;

    constructor() {
    }

    ngOnInit() {
      this.dropdown = false;
      this.initSourceList();
      if (this.showAny === undefined) {
        this.showAny = true;
      }

      if (this.eventValidate) {
        this.eventValidateSubscription = this.eventValidate.subscribe((listId) => {
          if (listId.includes(this.id)) {
            this.showError = !this.dropdownLabel;
          } else {
            this.showError = false;
          }
        });
      }
    }

    isResponseOperator() {
      return this.operatorSelected === 'Response given';
    }

    initSourceList() {
        this.sourceList = [];
        this.sourceList.push({ answer: 'True', isChecked: false});
        this.sourceList.push({ answer: 'False', isChecked: false});
    }

    onClickOutside(event: Object) {
      if (event && event['value'] === true) {
        this.dropdown = false;
      }
    }

    toggleDropdown() {
      if (!this.disabled) {
        this.dropdown = !this.dropdown;
      }
    }

    onChangeInput(event) {
      this.inputValue = event.target.value;
      this.userChoice.emit(this.inputValue);
    }

    @Input()
    get input() {
      return this.inputValue;
    }

    set input(val) {
      this.inputValue = val;
      this.userChoice.emit(this.inputValue);
    }

    changeLabel(s) {
      if (s === 'Any') {
        this.dropdownLabel = s;
      } else {
        if (this.fieldName === undefined || this.fieldName === '') {
          this.dropdownLabel = s;
        } else {
          this.dropdownLabel = s[this.fieldName];
        }
      }
      this.userChoice.emit(s.answer);
      this.showError = false;
    }

    setDefaultDropdownLabel(s: string) {
      this.dropdownLabel = s;
    }

    ngOnDestroy(): void {
      if (this.eventValidateSubscription) {
        this.eventValidateSubscription.unsubscribe();
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/text-custom-dropdown/text-custom-dropdown.component.ts